let label_en_US = {
    "firstName": "First Name",
    "lastName": "Last Name",
   /* "addressLine2": "Address Line 2",*/
    "country": "Country",
    "selectCountry": "Select Country",
    "city": "City",
    "zipOrPostalCode": "Zip/Postal Code",
    "pin":"PIN",
    "model" : "Model",
    "useBetween": "Amount of Use between",
    "warrantyreport" : "Warranty Reports",
    "claimsearch" :"Claim Search",
    "external_link" :"External Links",
    "feedback" :"Feedback",
    "whats_new" :"What's New",
    // "" :"Switch to old Warranty Report", // W361
    // "" :"If you see any issues in new application please provide the feedback. We have enabled the legacy Warranty reports link temporarily. ", //W362
    "search_dealer" :"Search by Dealer",
    "search_customer" :"Search by Customer",
    "claim_number" :"Claim Number",
    "search" :"Search", //W367
    "message1" :"Please enter a partial or complete PIN.",
    "hi" :"Hi",
    "dealer" :"Dealer",
    "dealivery_date" :"Delivery Date Between",
    "enter_dealer_account" :"Enter Dealer Account Number",
    "enter_model" :"Enter Model",
    "enter_serial_no" :"Enter Serial Number",
    "middle_name" :"Middle Name",
    "stateProvince" :"State",
    "enter_business_name" :"Enter Business Name",
    "engine_option" :"Engine Options",
    "mpr" :"Machine Population Report",
    "machine_list" :"Machine List",
    "print_to_pdf" :"Print to PDF",
    "export_data" :"Export Data",
    "export_all" :"Export All",
    "results" :"Results",
    "prevoious" :"Previous",
    "next" :"Next",
    "description" :"Description",
    "model_year" :"Model Year",
    "sold_as" :"Sold As",
    "last_rep_meas" :"Last Rep Meas",
    "delivery_date" :"Delivery Date",
    "responsible_dealer" :"Responsible Dealer",
    "customer_name" :"Customer Name",
    "machine_details" :"Machine Details",
    "customer" :"Customer",
    "home" :"Home",
    "cell" :"Cell",
    "work" :"Work",
    "selling_dealer" :"Selling Dealer",
    "customer_number" :"Customer Number",
    "purchase_type" :"Purchase Type",
    "end_use_code" :"End Use Code",
    "settlement_date" :"Settlement Date",
    "invoive_date" :"Invoice Date",
    "registration_date" :"Registration Date",
    "machine_build_date" :"Machine Build Date",
    "last_reported_registration" :"Last Reported Registration Measurement",
    "machine_status" :"Machine Status",
    "warranty_coverage" :"Warranty Coverage",
    "filter_warranty_type" :"Filter Warranty Type",
    "warranty_type" :"Warranty Type",
    "coverage_term" :"Coverage Term",
    "filter_coverage_term" :"Filter Coverage Term",
    "expiration_date" :"Expiration Date",
    "filter_expiration_date" :"Filter Expiration Date",
    "days_remaining" :"Days Remaining(may be estimate)",
    "filters_days_remaining" :"Filter Days Remaining(may be estimate)",
    "hours_limit" :"Hours Limit",
    "filter_hours_limit" :"Filter Hours Limit",
    "deductible_amt" :"Deductible Amount",
    "filter_deductible_amt" :"Filter Deductible Amount",
    "message2" :"No Components found for the product.",
    "component_serial_no" :"Component Serial Numbers",
    "base_option_code" :"Order Base/Option Codes",
    "code1" :"Code",
    "component1" :"Component",
    "filter_code" :"Filter Code",
    "filter_component" :"Filter Component",
    "base_machine_code" :"Base Machine Code",
    "filter_base_machine_code" :"Filter Base Machine Code",
    "customer_history" :"Customer History",
    "customer_1_1" :"Customer 1 of 1",
    "pip_number" :"PIP Number",
    "pip_type" :"PIP Type",
    "pip_participation_type" :"PIP Participation Type",
    "pip_title" :"PIP Title",
    "pip_status" :"PIP Status",
    "filter_pip_number" :"Filter PIP Number",
    "filter_pip_type" :"Filter PIP Type",
    "filter_pip_participation_type" :"Filter PIP Participation Type",
    "filter_pip_status" :"Filter PIP Status",
    "message3" :"No Claim history found for this search criteria.",
    "claim_history" :"Claim History",
    "pip_history" :"PIP History",
    "message4" :"Last Name' must be accompanied by Country and (City or State/Prov)",
    "message5" :"Business Name' must be accompanied by Country and (City or State/Prov)",
    "message6" :"Please enter a valid claim number",
    "basic_claim_details" :"Basic Claim Details",
    "claim_sequence_no" :"Claim Sequence Number",
    "claim_type" :"Claim Type",
    "dealer_ac" :"Dealer Account",
    "ownership_status" :"Ownership Status",
    "measurement" :"Measurement",
    "reference" :"Reference",
    "credit_memo" :"Credit Memo",
    "failure_part_serial" :"Failure Part Serial ",
    "failure_date" :"Failure Date",
    "process_date" :"Process Date",
    "failure_info" :"Failure Information",
    "failure_part" :"Failure Part",
    "failure_mode" :"Failure Mode",
    "failure_area" :"Failure Area",
    "failure_mode_comments" :"Failure Mode Comments",
    "downtime" :"Downtime",
    "prevoius_invoice" :"Previous Invoice",
    "test_results_code" :"Test Results Code",
    "dtac_case" :"DTAC Case",
    "dtac_solutions" :"DTAC Solution",
    "parts_labor" :"Parts / Labor / Other Credits",
    "iteam" :"Item", //W486
    "quantity_approved" :"Quantity Approved",
    "complaint" :"Complaint",
    "cause" :"Cause",
    "correction" :"Correction",
    "selected_dealer_id" :"Selected Dealer Ids:",
    "message7" :"Search may take longer time to complete. Narrowing your search will improve the response. Press OK to continue with the current search criteria or Cancel to add more filters.",
    "message8" :"The export of all records may take some time. You can continue using Warranty Reports while the download is in progress.",
    "choose_language" :"Choose Language",
    "message9" :"Copyright © 2024 Deere & Company. All rights reserved",
    "prefix" :"prefix",
    "streetAddress" :"Address",
    "addressLine2" :"Address 2",
    "customer_list" :"Customer List",
    "message10" :"No Option Codes found for the Product.",
    "message11" :"No customer found for the machine.",
    "message12" :"No Claim history found for this search criteria.",
    "message13" :"No PIP history found for the Product.",
    "enter_last_name" :"Enter Last Name    ",
    "enter_middle_name" :"Enter Middle Name",
    "enter_first_name" :"Enter First Name",
    "enter_state" :"Enter State",
    "enter_city" :"Enter City",
    "state_province" :"State/Province",
    "company_name" :"Company Name ",
    "message14" :"No Machines found for customer",
    "claim" :"Claim",
    "fail_date" :"Fail Date",
    "repair_date" :"Repair Date",
    "filter_dealer" :"Filter Dealer",
    "filter_claim" :"Filter Claim#",
    "filter_type" :"Filter Type",
    "filter_fail_date" :"Filter Fail Date",
    "filter_repair_date" :"Filter Repair Date",
    "filter_process_date" :"Filter Process Date",
    "filter_measurement" :"Filter Measurement",
    "warranty_option" :"Warranty Option",
    "expires_in_days" :"Expires in days",
    "filter_pin" :"Filter Pin",
    "filter_model" :"Filter Model",
    "filter_description" :"Filter Description",
    "filter_delivery_date" :"Filter Delivery Date",
    "filter_responsible_dealer" :"Filter Responsible Dealer",
    "filter_warranty_option" :"Filter Warranty Option",
    "filter_expires_in_days" :"Filter Expires in days",
    "expiration_report1" :"Expiration Report",
    "message15" :"* Retrieves all machines dealer is responsible for with this model and/or serial number",
    "individual":"Individual",
    "business":"Business",
    "machinesearch" : "Machine Serach",
    "date1":"dd-mmm-yyyy",
    "search_by_serial" :"Search By Serial Number",
    "select_multiple_dealer": "Select single or multiple dealer ids....",
    "serial_number" : "Serial Number",
    "SerialNumber":"SerialNumber",
    "message16" :"No machines found for this criteria.",
    "enter_Country": "Enter Country",
    "message17" : "No Customer found for this criteria.",
    "serial_no" : "Serial Number",
    "exportexcel" :"Export to Excel",
   "expiration_date_between": "Expiration Date Between",
    "ckc_id" :"CKC ID #",
    "customer_machines" :"Customer Machines",
    "PleaseSelectMessg":"Please Select",
};

export default label_en_US;